import { startCase as _startCase, toLower } from 'lodash'

export const startCase = (string) => {
  return _startCase(toLower(string))
}
